<template>
  <div>
    <label for="client" class="block text-sm font-medium text-gray-700">Select Client</label>
    <div class="mt-1">
      <input :value="selectedName" v-on:blur="clearList" v-on:focus="doSearch" v-on:input="doSearch" type="text" autocomplete="off" name="client" id="client"
class="py-2 px-2 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300
rounded-md" placeholder="Select a Client" />
    </div>
    <div class="mt-2">
      <template v-for="result in filteredResults" v-if="filteredResults">
        <button @click.prevent="() => handleClientSelected(result)" type="selection" class="flex w-full flex-col gap-1 bg-white px-3 py-1 border border-b-1 hover:cursor">
          {{ result.name }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import AutoComplete from '@trevoreyre/autocomplete-vue'
export default {
  name: "ClientSearchDropdown",
  components: {
    AutoComplete
  },
  props: ['clients'],
  emits: ['update:client'],
  data() {
    return {
      filteredResults: null,
      selectedClient: null,
      searchInput: ''
    }
  },
  computed: {
    selectedName() {
      if (this.selectedClient) {
        return this.selectedClient.name
      }
      return this.searchInput
    }
  },
  methods: {
      clearList(e) {
        if (!e.relatedTarget || e.relatedTarget.getAttribute('type') != 'selection') {
          this.filteredResults = null
        }
      },
      doSearch(input) {
        this.searchInput = input.target.value
        if (this.selectedClient && this.searchInput != this.selectedClient.name) {
          this.selectedClient = null
          this.$emit('update:client', this.selectedClient)
        }
        if (this.searchInput == '') {
          this.filteredResults = this.clients.slice(0, 10)
        } else {
          this.filteredResults = this.clients.filter(client => {
            return client.name.toLowerCase().includes(this.searchInput.toLowerCase())
          })
        }
    },
    handleClientSelected(result) {
        this.selectedClient = result
        this.filteredResults = null
        this.$emit('update:client', this.selectedClient)
      }
  }
}
</script>

<style scoped>

</style>
